module.exports = {"explore":{"title":"Pokračujte"}};